// ===================================================================
// Import modules
// ===================================================================
import "./i18n";

import { applyPolyfills, defineCustomElements } from "amwell-visit-console/loader";
import * as React from "react";
import * as ReactDOM from "react-dom";

// ===================================================================
// Import components
// ===================================================================
import AppRoot from "/component/root/AppRoot";
import { initDatadog } from "/util/datadog";

if (process.env.APP_ENV === "uat" || process.env.APP_ENV === "prod") {
  initDatadog();
}

applyPolyfills().then(() => {
  defineCustomElements(window).then(() => {
    ReactDOM.render(<AppRoot />, document.getElementById("root"));
  });
});
